module.exports = __webpack_public_path__ + "static/media/instagram.37d71118.png";